<template>
    <div class="field">
      <h5 class="title is-6 is-spaced">{{ label }}</h5>
      <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'FormSection',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/FormSection.vue